import { useQuery } from '@tanstack/react-query';
import { useEffect } from 'react';
import getData from '../../api/queries/getData';
import { selectUser } from '../../redux/auth/authSlice';
import { setData } from '../../redux/data/dataSlice';
import { useAppDispatch, useAppSelector } from '../../redux/hooks';

const useData = () => {
  const user = useAppSelector(selectUser);

  const { data, isLoading, isSuccess, error, refetch } = useQuery({
    queryKey: ['getData', user?.activeStore?._id],
    enabled: !!user && !!user?.activeStore?._id,
    queryFn: () => (user?.activeStore?._id ? getData(user.activeStore._id) : null),
  });

  return {
    data,
    isLoading,
    isSuccess,
    error: error,
    refetch,
  };
};

const useDataStoreSetter = () => {
  const { data, refetch, isLoading, isSuccess } = useData();
  const dispatch = useAppDispatch();
  useEffect(() => {
    if (data && isSuccess) {
      dispatch(setData(data));
    }
  }, [dispatch, isSuccess, data]);

  return { data, isLoading, refetch };
};

export { useData, useDataStoreSetter };
